import { TEmployeeRole } from '../typings/employees.types'

// user/employee is suspended – can’t use our services until he changes his password
export const isSuspendedRole = (role: TEmployeeRole) => {
  return role.enum === `SUSPENDED_USER`
}
